import register from '../entrypoint';
import UpcomingEventWidgetContainer from '../widgets/container/UpcomingEventWidgetContainer';

// Styles
import '../stylesheets/widgets.scss';

register({ UpcomingEventWidgetContainer });
